export default __webpack_public_path__ + "static/media/resources.63295a67.png";